module.exports = __webpack_public_path__ + "static/media/roulette_casino_bg_mus.bfb14948.mp3";